"use client";

import Link from "next/link";
import {
  FoodCreatorHero,
  FoodCreatorPerks,
  FoodCreatorProcess,
  FoodCreatorStudioIntro,
} from '@/components/cooking';

const sectionLinks = [
  { href: "#overview", label: "Overview" },
  { href: "#start", label: "Get started" },
  { href: "#why-creators", label: "Why creators" },
  { href: "#kitchens", label: "Kitchens" },
];

export default function BecomeAFoodCreatorPage() {
  return (
    <main className="relative bg-[linear-gradient(180deg,#fff6f1_0%,#fff1ed_44%,#f4fbf6_100%)] text-[#02120A]">
      <FoodCreatorHero />
      <nav className="sticky top-[var(--header-height,0px)] z-20 border-b border-[#ff5f47]/16 bg-[#fff5f0]/94 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 overflow-x-auto px-6 py-4 sm:px-8 lg:px-10">
          <div className="flex min-w-max items-center gap-5">
            {sectionLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="font-satoshi text-sm font-medium text-[#02120A]/66 transition hover:text-[#FF5F47]"
              >
                {link.label}
              </a>
            ))}
          </div>

          <Link
            href="/become-a-food-creator/apply?type=food-creator"
            className="inline-flex min-w-max items-center justify-center rounded-full bg-[#0A5C36] px-4 py-2.5 font-satoshi text-sm font-bold text-white transition hover:bg-[#0d6d40]"
          >
            Apply to cook
          </Link>
        </div>
      </nav>
      <FoodCreatorProcess />
      <FoodCreatorPerks />
      <FoodCreatorStudioIntro />
    </main>
  );
}
